import apiWrapper from 'Helpers/apiWrapper'

import { type TaskDetails } from 'Types/beAsyncTasks'

const endpoints = ((baseURL) => {
  return {
    getTask: (idTask: number) =>
      `${baseURL}/api/task/${encodeURIComponent(idTask)}`
  }
})(process.env.BEASYNCTASKS_URL as unknown as string)

export const beAsyncTasksApiGetTask = async (
  idTask: number
): Promise<TaskDetails> => {
  return await apiWrapper({
    method: 'get',
    url: endpoints.getTask(idTask),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}
